import { render, staticRenderFns } from "./USBrandOfferTable.vue?vue&type=template&id=d5a6655c&"
import script from "./USBrandOfferTable.vue?vue&type=script&lang=js&"
export * from "./USBrandOfferTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports